var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { st, classes } from './LegacyCard.st.css';
import { TPAComponentsConsumer, TPAComponentsContext, } from '../TPAComponentsConfig';
import { deprecationLog } from '../../common/deprecationLog';
import { LegacyCardDataHooks } from './constant';
import { LegacyCardRatioOptions } from './types';
export { LegacyCardRatioOptions } from './types';
var LegacyCard = /** @class */ (function (_super) {
    __extends(LegacyCard, _super);
    function LegacyCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegacyCard.prototype.componentDidMount = function () {
        deprecationLog('LegacyCard', 'The current `LegacyCard` component will be deprecated in the next major version. Please use the `Card` component instead.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--card');
    };
    LegacyCard.prototype.getRatio = function () {
        var _a = this.props, mediaAspectRatio = _a.mediaAspectRatio, stacked = _a.stacked;
        if (mediaAspectRatio) {
            return mediaAspectRatio && Math.round(100 / mediaAspectRatio) + "%";
        }
        return (stacked ? 100 : 0) + "%";
    };
    LegacyCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, info = _a.info, media = _a.media, ratio = _a.ratio, invertInfoPosition = _a.invertInfoPosition, flippedRatio = _a.flippedRatio, stacked = _a.stacked, mediaAspectRatio = _a.mediaAspectRatio, className = _a.className;
        var cardRatio = media ? ratio : LegacyCardRatioOptions.RATIO_100;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile;
            return (React.createElement("div", { className: st(classes.root, {
                    ratio: cardRatio,
                    invertInfoPosition: invertInfoPosition,
                    flippedRatio: flippedRatio,
                    stacked: stacked,
                    mobile: mobile,
                    mediaAspectRatio: !!mediaAspectRatio || stacked,
                }, classes.deprecated, className), "data-hook": _this.props['data-hook'], "data-mobile": mobile, "data-is-inverted": invertInfoPosition, "data-is-flipped-ratio": flippedRatio, "data-ratio": cardRatio },
                media && ratio !== LegacyCardRatioOptions.RATIO_100 && (React.createElement("div", { className: classes.mediaWrapper, style: { paddingTop: _this.getRatio() } },
                    React.createElement("div", { className: classes.mediaContainer, "data-hook": LegacyCardDataHooks.mediaContainer }, media))),
                info && (React.createElement("div", { className: classes.infoContainer, "data-hook": LegacyCardDataHooks.infoContainer }, info))));
        }));
    };
    LegacyCard.contextType = TPAComponentsContext;
    LegacyCard.displayName = 'Card';
    LegacyCard.MIN_WIDTH = 700;
    LegacyCard.MIN_WIDTH_MOBILE = 130;
    LegacyCard.defaultProps = {
        ratio: LegacyCardRatioOptions.RATIO_50_50,
        flippedRatio: false,
        invertInfoPosition: false,
        stacked: false,
    };
    return LegacyCard;
}(React.Component));
export { LegacyCard };
//# sourceMappingURL=LegacyCard.js.map